<h2 mat-dialog-title>{{ data.title }}</h2>
<form [formGroup]="providerForm">
  <div style="display: flex; justify-content: space-around; flex-wrap: wrap">
    <div style="display: flex; flex-direction: column">
      <mat-form-field appearance="outline">
        <mat-label>Nombre Comercial</mat-label>
        <input
          matInput
          placeholder="Nombre Comercial"
          formControlName="nombreComercial"
          name="nombreComercial"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Provincia</mat-label>
        <input
          matInput
          placeholder="Provincia"
          formControlName="provincia"
          name="provincia"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Dirección</mat-label>
        <input
          matInput
          placeholder="Dirección"
          formControlName="direccionSocial"
          name="direccionSocial"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nro Documento</mat-label>
        <input
          matInput
          placeholder="Nro Documento"
          formControlName="documento"
          name="documento"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Cuenta Contable Soles</mat-label>
        <input
          matInput
          placeholder="Cuenta Contable Soles"
          formControlName="cuentaContableSoles"
          name="cuentaContableSoles"
          required
        />
      </mat-form-field>
    </div>

    <div style="display: flex; flex-direction: column">
      <mat-form-field appearance="outline">
        <mat-label>Razón Social</mat-label>
        <input
          matInput
          placeholder="Razón Social"
          formControlName="razonSocial"
          name="razonSocial"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Distrito</mat-label>
        <input
          matInput
          placeholder="Distrito"
          formControlName="distrito"
          name="distrito"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Teléfono</mat-label>
        <input
          matInput
          placeholder="Teléfono"
          formControlName="telefono"
          name="telefono"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>RUC</mat-label>
        <input
          matInput
          placeholder="RUC"
          formControlName="ruc"
          name="ruc"
          required
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Cuenta Contable Dolares</mat-label>
        <input
          matInput
          placeholder="Cuenta Contable Dolares"
          formControlName="cuentaContableDolares"
          name="cuentaContableDolares"
          required
        />
      </mat-form-field>
    </div>
  </div>

  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cancelar</button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="this.data.estado == 1"
      (click)="updateProvider()"
    >
      {{ data.title }}
    </button>
    <button
      mat-raised-button
      color="primary"
      *ngIf="this.data.estado == 2"
      (click)="createProvider()"
    >
      {{ data.title }}
    </button>
  </mat-dialog-actions>
</form>
